/** Session flag: EHR launch uses redirect_uri …/callback/ehr (same Okta SPA as standard login). */
export const ACCOUNT_UI_OIDC_MODE_SESSION_KEY = 'ACCOUNT_UI_OIDC_MODE';
export const ACCOUNT_UI_OIDC_MODE_EHR = 'ehr';

export function isEhrOidcAuthMode() {
  if (typeof window === 'undefined' || !window.sessionStorage) {
    return false;
  }
  try {
    return window.sessionStorage.getItem(ACCOUNT_UI_OIDC_MODE_SESSION_KEY) === ACCOUNT_UI_OIDC_MODE_EHR;
  } catch {
    return false;
  }
}

export function setEhrOidcAuthMode() {
  if (typeof window === 'undefined' || !window.sessionStorage) {
    return;
  }
  try {
    window.sessionStorage.setItem(ACCOUNT_UI_OIDC_MODE_SESSION_KEY, ACCOUNT_UI_OIDC_MODE_EHR);
  } catch {
    // ignore quota / private mode
  }
}

export function clearEhrOidcAuthMode() {
  if (typeof window === 'undefined' || !window.sessionStorage) {
    return;
  }
  try {
    window.sessionStorage.removeItem(ACCOUNT_UI_OIDC_MODE_SESSION_KEY);
  } catch {
    // ignore
  }
}

/** True when loading the OAuth redirect handler for the EHR OIDC app (handles cold loads if the session flag was lost). */
export function isEhrOktaCallbackPath() {
  if (typeof window === 'undefined' || window.location?.pathname == null) {
    return false;
  }
  const path = String(window.location.pathname);
  return path === '/callback/ehr' || path.endsWith('/callback/ehr');
}
